import React from 'react';

export default function SplitPageContainer(props) {
    return (
        <div>
            <header className="split-page-header">
                <img src="/images/logo.png" alt="logo" className="logo" />
            </header>
            <div className="page split-page">
                <div className="left-column">
                    {props.children}
                </div>
                <div className="gradient">
                    <div>
                        <h3>{props.title}</h3>
                        <p>{props.subtitle}</p>
                    </div>
                </div>
            </div>
        </div>
    );
}




// WEBPACK FOOTER //
// ./src/components/commonComponents/shared/SplitPageContainer.jsx